import { Box, Input, InputAdornment, Typography } from '@mui/material';

interface SingleSettingItemProps {
  label: string;
  value: number | null;
  onChange: (value: number | null) => void;
}

const titleMapper = (value: string) => {
  switch (value) {
    case 'transcription':
      return 'Транскрибация';
    case 'summarization':
      return 'Саммаризация';
    case 'agreement_extraction':
      return 'Соглашения';
    case 'context_document_parsing':
      return 'Документы';
    default:
      return '';
  }
};

export const SingleSettingItem = ({ label, value, onChange }: SingleSettingItemProps) => {
  return (
    <Box
      sx={{
        padding: '16px',
        border: '1px solid #e0e0e0',
        borderRadius: '12px',
        backgroundColor: '#f9fafb',
        transition: 'box-shadow 0.2s',
        '&:hover': {
          boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
        },
      }}
    >
      <Typography variant="body2" color="text.secondary" gutterBottom>
        {titleMapper(label)}
      </Typography>
      <Input
        fullWidth
        size="small"
        type="number"
        inputProps={{ min: 0 }}
        value={value ?? ''}
        onChange={(e) => {
          const raw = e.target.value;
          onChange(raw === '' ? null : Number(raw));
        }}
        disableUnderline
        sx={{
          backgroundColor: 'white',
          padding: '4px 8px',
          borderRadius: '6px',
          border: '1px solid #d0d0d0',
          '& input': {
            padding: 0,
          },
        }}
        endAdornment={
          <InputAdornment position="end" sx={{ color: 'text.secondary' }}>
            Мб
          </InputAdornment>
        }
      />
    </Box>
  );
};

export default SingleSettingItem;
